<template>
  <div class="BuMenList">
    <div class="tableFilter">
      <div style="text-align: right">
        <el-button type="primary" @click="handleAddBuMen" plain
                   v-show="permissionCode.has('assist:depart:manager')"
        >新增部门
        </el-button>
      </div>
    </div>
    <XTable
        :api="getBuMenList"
        :state="buMenList"
        :columns="columns"
        :loading="isBack"
        :tableSize="tableSize"
        :maxHeight="maxHeight"
        :firstColumn="firstColumn"
        :layout="layout"
    ></XTable>
  </div>
</template>

<script>
import XTable from "@/components/XTable/index.vue";
import {mapActions, mapState} from "vuex";
import DateUtil from "@/utils/formatDate";

export default {
  name: "BuMenList",
  components: {XTable},
  props: {
    maxHeight: {
      type: Number,
      default() {
        return null;
      },
    },
  },
  data() {
    return {
      firstColumn: true,
      hasPagination: true,
      tableSize: "small",
      layout: "sizes, prev, pager, next",
      back: false,
    };
  },
  computed: {
    ...mapState("fuzhu", ["buMenList"]),
    ...mapState("teachingCenter", ["isBack"]),
    ...mapState("user", ["permissionCode"]),
    columns: function () {
      const self = this;
      const columns = [
        {
          label: "部门场景",
          render(h, scope) {
            return (
                <div>{(scope.row && scope.row.assistClassName) || "未分组"}</div>
            );
          },
        },
        {
          prop: "name",
          label: "部门",
        },
        {
          label: "角色数",
          render(h, scope) {
            return <div>{(scope.row && scope.row.count) || 0}</div>;
          },
        },
        {
          label: "编辑日期",
          render(h, scope) {
            return (
                <div>
                  <span>{self.formatDate(scope.row.updateTime)}</span>
                </div>
            );
          },
        },
      ];
      if (this.permissionCode.has('assist:depart:manager')) {
        columns.push({
          label: "调整顺序",
          width: 150,
          render(h, scope) {
            return (
                <div>
                  <el-button
                      onClick={() => {
                        self.handleUp(scope);
                      }}
                      disabled={self.isUp() && scope.$index === 0}
                      size="mini"
                      type="primary"
                      plain
                  >
                    上移
                  </el-button>
                  <el-button
                      onClick={() => {
                        self.handleDown(scope);
                      }}
                      disabled={self.isDown() === scope.$index}
                      size="mini"
                      type="primary"
                      plain
                  >
                    下移
                  </el-button>
                </div>
            );
          }
        });
        columns.push({
          label: "操作",
          fixed: "right",
          width: 250,
          render(h, scope) {
            return (
                <div>
                  {!scope.row.noEdit && (
                      <el-button
                          onClick={() => {
                            self.handleEdit(scope.row);
                          }}
                          size="mini"
                          type="primary"
                          plain
                      >
                        编辑
                      </el-button>
                  )}
                  {!scope.row.noEdit && (
                      <el-button
                          onClick={() => {
                            self.handleDelete(scope.row);
                          }}
                          size="mini"
                          type="danger"
                          plain
                      >
                        删除
                      </el-button>
                  )}
                  <el-button
                      onClick={() => {
                        self.handleAddRole(scope.row);
                      }}
                      size="mini"
                      type="primary"
                      plain
                  >
                    新增角色
                  </el-button>
                </div>
            );
          },
        })
      }
      return columns;
    }
  },
  methods: {
    ...mapActions("fuzhu", ["getBuMenList", "deleteBuMen", "moveAssistDepart"]),
    isUp() {
      return this.buMenList.page === 1;
    },
    isDown() {
      return this.buMenList.total - (this.buMenList.page - 1) * this.buMenList.size - 1;
    },
    // 上移
    async handleUp(scope) {
      await this.moveFun(true, scope);
    },
    // 下移
    async handleDown(scope) {
      await this.moveFun(false, scope);
    },
    // 移动方法
    async moveFun(previewDirect, scope) {
      const offset = (this.buMenList.page - 1) * this.buMenList.size + scope.$index + 1;
      this.move;
      await this.moveAssistDepart({
        ...this.filter,
        previewDirect: previewDirect,
        offset: offset,
        step: 1,
      }).then(() => {
            this.getBuMenList({
              ...this.filter,
              page: this.buMenList.page,
              size: this.buMenList.size,
            })
          }
      )
    },
    async handleAddRole(row) {
      await this.$router.push(
          {
            name: "AddRole",
            params: {
              type: "add",
              assistDepartId: row.id,
            },
          },
          () => {
          }
      );
    },
    async handleAddBuMen() {
      await this.$router.push(
          {
            name: "AddBuMen",
            params: {
              type: "add",
              id: 0,
            },
          },
          () => {
          }
      );
    },
    async handleEdit(row) {
      localStorage.setItem("buMenDetail", JSON.stringify(row));
      await this.$router.push(
          {
            name: "AddBuMen",
            params: {
              type: "edit",
              id: 0,
            },
          },
          () => {
          }
      );
    },
    handleDelete(row) {
      this.$confirm("请确认是否要删除该部门!", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        closeOnClickModal: false,
      })
          .then(async () => {
            await this.deleteBuMen({
              id: row.id,
            });
            await this.getBuMenList({
              page: this.buMenList.page,
              size: this.buMenList.size,
            });
          })
          .catch(() => {
          });
    },
    // 根据时间戳计算编辑日期
    formatDate(timestamp) {
      return DateUtil.formatDateFromTimestamp(timestamp);
    },
  },
};
</script>

<style lang="scss" scoped>
.BuMenList {
  .tableFilter {
    padding-bottom: 10px;
  }

  .el-form-item {
    margin-right: 20px;
  }

  ::v-deep .el-range-separator {
    width: 20px !important;
  }
}
</style>
